import { Outlet } from 'react-router-dom';

import { BreadCrumb } from '@/components/breadcrumb/breadcrumb';
import { AppSidebar } from '@/components/sidebar/appSidebar';
import { SidebarInset } from '@/components/ui/sidebar';
import type { DashboardItem } from '@/models/dashboardItem';
import { useSandboxContext } from '@/providers/SandboxProvider';

interface DashboardProps {
  items?: DashboardItem[];
  menu: boolean;
}

const Dashboard = (props: DashboardProps) => {
  const { selectedSandbox } = useSandboxContext();
  return (
    <>
      <AppSidebar items={props.items?.filter((item) => !item.disabled)} />
      <SidebarInset key={selectedSandbox} className="isolate">
        <BreadCrumb />
        <div className="layout overflow-x-auto">
          <Outlet />
        </div>
      </SidebarInset>
    </>
  );
};

export default Dashboard;
